import { graphql } from '~gql';

export const LOGIN = graphql(`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      token
      user {
        ...SessionUser
      }
    }
  }
`);

export const SEND_LOGIN_CODE = graphql(`
  mutation SendLoginCode($contactInfo: ContactInfoInput!) {
    sendLoginCode(contactInfo: $contactInfo)
  }
`);

export const LOGIN_WITH_CODE = graphql(`
  mutation LoginWithCode($input: LoginWithCodeInput!) {
    loginWithCode(input: $input) {
      token
      user {
        ...SessionUser
      }
    }
  }
`);
